namespace Indexes {
    export class Customer
        implements StaticIndexDefinition {

        name = "CustomerAll";
        maps = [
            "from u in docs.Customers select new { u.lastName }"
        ];
    }
}